import { render, staticRenderFns } from "./addr.vue?vue&type=template&id=797a4724&scoped=true"
import script from "./addr.vue?vue&type=script&lang=js"
export * from "./addr.vue?vue&type=script&lang=js"
import style0 from "./addr.vue?vue&type=style&index=0&id=797a4724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a4724",
  null
  
)

export default component.exports